import React, {useContext, useEffect, useState} from 'react';
import {Grid, Snackbar} from '@material-ui/core';
import InputField from '../../../../FormikUtils/InputField'
import SelectField from '../../../../FormikUtils/SelectField'
import {Field, useFormikContext} from 'formik'
import FormikAutocomplete from '../../../../FormikUtils/FormikAutocomplete'
import {useIsMount} from "../../../../../useIsMount";
import Alert from '@material-ui/lab/Alert';
import {makeStyles} from "@material-ui/core/styles";
import RegularInputField from "../../../../../RegularInputField";
import withMultipleContexts from "../../../../../../context/utils/withMultipleContexts";
import loadAutomotorData from "../../../../../../context/products/AutomotorContext/loadAutomotorData";
import AutomotorContextProvider from "../../../../../../context/products/AutomotorContext/AutomotorContextProvider";
import AutomotorContext from "../../../../../../context/products/AutomotorContext/AutomotorContext";
import {findSelectedLabel} from "../../../../../utils/findSelectedLabel";

const useStyles = makeStyles((theme) => ({
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
}));



function CoberturaForm(props) {
    const classes = useStyles();
    const {
        formField: {
            vehiculo: {
                marca,
                anio,
                modelo,
                version,
                sumaAseguradaAdicional,
                esCeroKm,
                tieneGnc,
                sumaAseguradaGnc,
            }
        },
        cotizacionRetomada,
        vehicleDetails
    } = props;

    const {
        marcas,
        anios,
        modelos,
        versiones,
        updateModels,
        updateVersions,
        handleRecotizarInitialValues,
        isLoadingModels,
        isLoadingVersions,
    } = useContext(AutomotorContext);

    const {values, setFieldValue} = useFormikContext();
    const isMount = useIsMount();

    const cerokm_options = [
        {value: 'true', label: 'Si'},
        {value: 'false', label: 'No'}
    ];

    const gnc_options = [
        {value: '1', label: 'Si'},
        {value: '0', label: 'No'}
    ];

    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    function handleValueChange(e) {
        let value = e.target.value;
        if (!value.match(/^[1-9]\d*$/))
            value = 0;
        else value = parseInt(value);

        let minValue = 450000
        let maxValue = 3000000

        if (value < minValue) {
            handleOpenAlert(`El valor mínimo para equipo de GNC es de $ ${minValue}`);
            value = minValue
        }

        if (value > maxValue) {
            handleOpenAlert(`El valor máximo para equipo de GNC es de $ ${maxValue}`);
            value = maxValue

        }
        setFieldValue("sumaAseguradaGnc", value)
    }

    useEffect(() => {
        if (cotizacionRetomada) {
            let marcaValue = values.vehiculo.marca;
            switch (values.vehiculo.detalle_marca) {
                case 'JEEP':
                    marcaValue = "13-0";
                    break;
                case 'DODGE':
                    marcaValue = "13-1";
                    break;
                case 'RAM':
                    marcaValue = "13-2";
                    break;
                default:
                    break;
            }
            setFieldValue(marca.name, marcaValue, false);
            handleRecotizarInitialValues(values.vehiculo.modelo, values.vehiculo.detalle_modelo, values.vehiculo.version, values.vehiculo.detalle_version, values.vehiculo.detalle_marca, vehicleDetails);
        }
    }, []);

    useEffect(() => {
        if (isMount) {      // isMount is true if it's the first render of the component
            // setFieldValue(sumaAseguradaGnc.name, valuesMemo['Valor_GNC'], false);
            if (cotizacionRetomada) {
                updateModels(values.vehiculo.marca, values.vehiculo.anio);
            }
        } else {
            if (values.vehiculo.anio !== '') {
                if (typeof values.vehiculo.marca !== 'string') {
                    setFieldValue(modelo.name, '', false);
                    setFieldValue(version.name, '', false);
                }
                updateModels(values.vehiculo.marca, values.vehiculo.anio, true);
            }
        }
    }, [values.vehiculo.anio, values.vehiculo.marca]);

    useEffect(() => {
        if (isMount) {
            if (cotizacionRetomada) {
                updateVersions(values.vehiculo.marca, values.vehiculo.anio, values.vehiculo.modelo);
            }
        } else {
            if (values.vehiculo.modelo !== '') {
                setFieldValue(version.name, '', false);
                updateVersions(values.vehiculo.marca, values.vehiculo.anio, values.vehiculo.modelo, true);
            }
        }
    }, [values.vehiculo.modelo]);

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                    <Field
                        name={marca.name}
                        label={marca.label}
                        component={FormikAutocomplete}
                        options={marcas}
                        textFieldProps={{
                            label: marca.label,
                            required: true,
                        }}
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_marca: findSelectedLabel(marcas, value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <SelectField
                        name={anio.name}
                        label={anio.label}
                        data={anios}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Field
                        name={modelo.name}
                        label={modelo.label}
                        loading={isLoadingModels}
                        component={FormikAutocomplete}
                        options={modelos}
                        textFieldProps={{
                            label: modelo.label,
                            required: true,
                        }}
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_modelo: findSelectedLabel(modelos, value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        name={version.name}
                        label={version.label}
                        loading={isLoadingVersions}
                        component={FormikAutocomplete}
                        options={versiones}
                        textFieldProps={{
                            label: modelo.label,
                            required: true,
                        }}
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_version: findSelectedLabel(versiones, value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={esCeroKm.name}
                        label={esCeroKm.label}
                        data={cerokm_options}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={sumaAseguradaAdicional.name}
                        label={sumaAseguradaAdicional.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={tieneGnc.name}
                        label={tieneGnc.label}
                        data={gnc_options}
                        fullWidth
                    />
                </Grid>
                {values.vehiculo.tieneGnc === '1' && (
                    <Grid item xs={12} sm={6}>
                        <RegularInputField
                            name={sumaAseguradaGnc.name}
                            label={sumaAseguradaGnc.label}
                            onBlur={(e) => handleValueChange(e)}
                            fullWidth
                            textTransform={'uppercase'}
                        />
                    </Grid>
                )}
            </Grid>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}

export default withMultipleContexts(CoberturaForm, [
    {
        loadDataFunctions: [loadAutomotorData],
        ContextProvider: AutomotorContextProvider,
        dataKey: 'automotorData',
        storageKey: 'automotorData',
    }
])
